import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = ({ redirectTo }: { redirectTo: string }) => {
  const isAuthenticated = !!localStorage.getItem("accessToken");
  return isAuthenticated ? <Navigate to={redirectTo} replace /> : <Outlet />;
};

export default PublicRoute;
